'use client';

import React, { useEffect } from 'react';

import { usePictureViewerContext } from 'providers/picture-viewer-provider';

import { styles } from '.';
import PictureItem from '../PictureItem';

type TProps = {
  pictures: any[];
  //
  lang: string;
};

const PictureViewer = (props: TProps) => {
  const { pictures } = props;

  const { setPictures, setSelector, setIsShown } = usePictureViewerContext();

  useEffect(() => {
    setPictures(pictures);
  }, [pictures, setPictures]);

  return (
    <div className={styles.container}>
      <ul className={styles.list}>
        {pictures?.map((picture: any, index: number) => (
          <PictureItem
            key={`${picture._key}-${index}`}
            picture={picture}
            onClick={() => {
              setPictures(pictures);
              setSelector(index);
              setIsShown(true);
            }}
          />
        ))}
      </ul>
    </div>
  );
};

export default PictureViewer;
